import {FeatureName} from '@hproduce/suite-core'
import {useParams} from 'react-router'

export const useFeatureName = () => {
  const {featureName} = useParams<{featureName: FeatureName}>()

  if (!featureName) {
    throw new Error('BUG: Feature name url param is required')
  }

  return featureName
}
